/**
 * Conversation List Container Component
 * Container component with business logic for managing a list of conversations
 */

import React, { useMemo } from 'react';
import { ConversationListPresenter } from './ConversationListPresenter';
import { useChatScreenStore } from '@/store/chatScreenStore';
import { ChatLocation } from '@/types/chatTypes';

export interface ConversationListContainerProps {
  conversationIds?: string[]; // Optional: filter specific conversations
  onPlaceSelect?: (location: ChatLocation, conversationId: string) => void;
  onCardClick?: (cardId: string, conversationId: string) => void;
  onPlaceNameClick?: (placeName: string, conversationId: string) => void;
}

export const ConversationListContainer: React.FC<
  ConversationListContainerProps
> = ({ conversationIds, onPlaceSelect, onCardClick, onPlaceNameClick }) => {
  const { conversations } = useChatScreenStore();

  // Filter conversations if conversationIds is provided, otherwise show all
  const filteredConversations = useMemo(() => {
    if (conversationIds && conversationIds.length > 0) {
      return conversations.filter(conv => conversationIds.includes(conv.id));
    }
    // Show all conversations, sorted by updatedAt (most recent first)
    return [...conversations].sort((a, b) => b.updatedAt - a.updatedAt);
  }, [conversations, conversationIds]);

  return (
    <ConversationListPresenter
      conversations={filteredConversations}
      onPlaceSelect={onPlaceSelect}
      onCardClick={onCardClick}
      onPlaceNameClick={onPlaceNameClick}
    />
  );
};
